import React from 'react';
import { Outlet } from "react-router-dom";
import Navigation from "../navigation/navigation.js";

const Layout = () => {
  return (
    <>
      <div style={{marginBottom: "75px"}}>
        <Navigation/>
      </div>

      <Outlet />
    </>
  )
};

Layout.propTypes = {};
Layout.defaultProps = {};

export default Layout;
